export enum Locations {
    Root = '/',
    Edit = '/edit',
    Audiences = '/audiences',
    UsersPermissions = '/usersPermissions'
}
